module.exports = __webpack_public_path__ + "static/media/Informationbanner@3x.0bf15dc0.png";